import { Component, ViewEncapsulation, Injector, ViewChild, OnInit } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SurveysServiceProxy, CreateOrEditSurveyDto, CreateOrEditSurveyAnswerDto, CreateOrEditQuestionDto, CreateOrEditQuestionAnswerDto, CreateOrEditSurveyContactDto, RegistrationsServiceProxy, UserServiceProxy, UserViewDto } from '@shared/service-proxies/service-proxies';
import { QuestionType } from '@shared/AppEnums';
import { CertificateModalComponent } from '@app/event/my-registrations/modal/certificate-modal.component';

import * as _ from 'lodash';
import { MessageService } from 'abp-ng2-module/src/message/message.service';

export interface IAnswer {
  questionId?: number | undefined;
  optionId?: number | undefined;
  textComment?: string | undefined;
  contact?: CreateOrEditSurveyContactDto | undefined;
  subQuestions?: IAnswer[] | undefined;
  selected?: boolean | undefined;
}

export interface IAnswerSurvey {
  answers: IAnswer[];
}

@Component({
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class AnswerComponent extends AppComponentBase implements OnInit {

  @ViewChild('certificateModal') certificateModal: CertificateModalComponent;

  questionType = QuestionType;

  user: UserViewDto = undefined;
  survey = new CreateOrEditSurveyDto();
  surveyQuestions: CreateOrEditQuestionDto[] = [];
  answerSurvey: IAnswerSurvey;
  userRegistration = undefined;

  surveyId = 0;
  registrationId = 0;
  userId = 0;
  indexQuestionContact: number = undefined;

  saving = false;
  showButton = true;

  constructor(
    injector: Injector,
    private _router: Router,
    private _surveysServiceProxy: SurveysServiceProxy,
    private _registrationsService: RegistrationsServiceProxy,
    private activatedRoute: ActivatedRoute,
    private _userService: UserServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.surveyId = +params['surveyId'];
      this.registrationId = +params['registrationId'];
      this.userId = +params['userId'];
    });

    this.block('.m-portlet');

    this.loadUser();
    this.loadRegistration();
    this.loadSurvey();
  }

  loadUser(): void {
    if (this.userId == 0)
      this.userId = abp.session.userId

    this._userService.getUserForView(this.userId).subscribe(result => {

      if (!!result.user.id) {
        this.user = result.user;
        this.loadUserInContact();
      }
    });
  }

  loadRegistration(): void {
    this._registrationsService.getUserRegistrations(
      this.userId,
      undefined,
      undefined,
      undefined,
      this.registrationId
    )
      .subscribe(result => {
        this.userRegistration = result.items[0];
        if (this.userRegistration && this.userRegistration.answeredSurvey)
          this.goToMyRegistrations();
      });
  }

  loadSurvey(): void {

    this.answerSurvey = {
      answers: []
    };

    this._surveysServiceProxy.getSurveyForAnswer(this.surveyId, undefined)
      .finally(() => {
        this.unBlock('.m-portlet');
      })
      .subscribe(result => {

        if (result.survey && result.survey.isActive) {

          let i = 0
          this.survey = result.survey;

          result.survey.questions.forEach((question) => {
            if (!question.parentId) {

              this.surveyQuestions.push(question);

              let _answer: IAnswer = {};
              _answer.questionId = question.id;

              if (question.type == QuestionType.ContactInformation)
                _answer.contact = new CreateOrEditSurveyContactDto();

              if (question.type == QuestionType.BoxSelection || question.type == QuestionType.Group) {
                _answer.subQuestions = [];
                question.subQuestions.forEach(x => {
                  let subAnswer: IAnswer = {};
                  subAnswer.questionId = x.id;
                  _answer.subQuestions.push(subAnswer);
                })
              }

              this.answerSurvey.answers.push(_answer);

              if (question.type == QuestionType.ContactInformation) {
                this.indexQuestionContact = i;
                this.loadUserInContact();
              }

              i++;
            }
          });
        }
        else {
          this.message.warn(this.l('SurveyNotFoundOrInactive'));
        }
      });
  }

  loadUserInContact(): void {

    if (this.indexQuestionContact != undefined && this.user) {
      this.answerSurvey.answers[this.indexQuestionContact].contact.name = this.user.name;
      this.answerSurvey.answers[this.indexQuestionContact].contact.cpf = this.user.userName;
      this.answerSurvey.answers[this.indexQuestionContact].contact.email = this.user.emailAddress;
      if (this.user.phones.length > 0) {
        this.answerSurvey.answers[this.indexQuestionContact].contact.phone = this.user.phones[0].ddi + this.user.phones[0].ddd + this.user.phones[0].number;
      }
    }
  }

  skip(): void {
    let model = new CreateOrEditSurveyAnswerDto();
    model.answers = [];
    model.userId = this.userId;
    model.surveyId = this.surveyId;
    model.registrationId = this.registrationId;

    this._surveysServiceProxy.skipAnswer(model)
      .finally(() => { this.saving = false; })
      .subscribe((result) => {
        this.userRegistration.answeredSurvey = true;
        this.certificateModal.show(this.userRegistration, this.userRegistration.event.certificateReleased, this.userId);
        this.showButton = false;
      });
  }

  save(): void {

    this.saving = true;

    let model = new CreateOrEditSurveyAnswerDto();
    model.answers = [];
    model.userId = this.userId;
    model.surveyId = this.surveyId;
    model.registrationId = this.registrationId;

    this.answerSurvey.answers.forEach((x, i) => {

      let _answer = new CreateOrEditQuestionAnswerDto();
      _answer.questionId = x.questionId;

      if (this.surveyQuestions[i].type == QuestionType.MultipleChoice || this.surveyQuestions[i].type == QuestionType.StarRating) {
        _answer.optionId = x.optionId;
        _answer.textComment = x.textComment;
      }
      else if (this.surveyQuestions[i].type == QuestionType.Comment) {
        _answer.textComment = x.textComment;
      }
      else if (this.surveyQuestions[i].type == QuestionType.ContactInformation) {
        _answer.contact = new CreateOrEditSurveyContactDto();
        _answer.contact.name = x.contact.name;
        _answer.contact.cpf = x.contact.cpf;
        _answer.contact.email = x.contact.email;
        _answer.contact.phone = x.contact.phone;
      }
      else if (this.surveyQuestions[i].type == QuestionType.Group) {
        this.surveyQuestions[i].subQuestions.forEach((x, j) => {
          let _subQuestion = new CreateOrEditQuestionAnswerDto();
          _subQuestion.questionId = x.id;
          _subQuestion.optionId = this.answerSurvey.answers[i].subQuestions[j].optionId;
          model.answers.push(_subQuestion);
        });
        return;
      }
      else if (this.surveyQuestions[i].type == QuestionType.BoxSelection) {
        this.surveyQuestions[i].subQuestions.forEach((x, j) => {

          let _subQuestion = new CreateOrEditQuestionAnswerDto();
          _subQuestion.questionId = x.id;

          if (this.answerSurvey.answers[i].subQuestions[j].selected) {
            let optionYes = _.filter(this.surveyQuestions[i].subQuestions[j].options, { 'answerText': 'Sim' });
            _subQuestion.optionId = optionYes[0] ? optionYes[0].id : undefined;
          }
          else {
            let optionNo = _.filter(this.surveyQuestions[i].subQuestions[j].options, { 'answerText': 'Não' });
            _subQuestion.optionId = optionNo[0] ? optionNo[0].id : undefined;
          }

          _subQuestion.textComment = this.answerSurvey.answers[i].subQuestions[j].textComment;
          model.answers.push(_subQuestion);
        });
        return;
      }
      model.answers.push(_answer);
    });

    this._surveysServiceProxy.createAnswer(model)
      .finally(() => { this.saving = false; })
      .subscribe((result) => {
        this.userRegistration.answeredSurvey = true;
        this.certificateModal.show(this.userRegistration, this.userRegistration.event.certificateReleased, this.userId);
        this.showButton = false;
      });
  }

  goToMyRegistrations(): void {
    this._router.navigate(['app/event/myRegistrations']);
  }
}



// WEBPACK FOOTER //
// ./src/app/event/surveys/answer/answer.component.ts